<loader [loading]="isLoading()" loadingContentContainerClass="h-100">
  <router-outlet />
</loader>
<version-no />
<toast-notifications />
